// extracted by mini-css-extract-plugin
module.exports = {"bottomNavigation":"bottomNavigation_bottomNavigation__1NIrh"};